<template>
  <hm-content title="">
    <div class="flex">
      <div class="left-wrapper">
        <div class="flex flex-center item-center">
          <img
            :src="basicInfo.avatar || defaultAvatar"
            alt="头像"
            class="headerImg"
          />
        </div>
        <div class="left-info">
          <div class="mt10">
            <span class="mr10 fontBold">姓名</span
            ><span>{{ basicInfo.idcard_name || basicInfo.guider_name }}</span>
          </div>
          <div class="mt10">
            <span class="mr10 fontBold">电话</span
            ><span>{{ basicInfo.auth_mobile }}</span>
          </div>
          <div class="mt10">
            <span class="mr10 fontBold">身份类型</span
            ><span>{{ basicInfo.type_desc }}</span>
          </div>
          <div class="mt10">
            <span class="mr10 fontBold">分销商城</span
            ><span>{{ basicInfo.store_name_group }}</span>
          </div>
        </div>
        <div class="flex flex-between order-info">
          <div class="flex flex-column item-center" @click="billWait">
            <div class="bold">{{waitNum}}单</div>
            <div class="text">审核中>></div>
          </div>
          <div class="flex flex-column item-center" @click="billRefuse">
            <div class="bold">{{handleNum}}单</div>
            <div class="text">30天内未通过>></div>
          </div>
        </div>
        <div class="flex flex-column item-center">
          <el-button
            type="primary"
            size="small"
            class="btn mt20"
            @click="blackReasonClick"
            >设置黑白名单</el-button
          >
          <el-button
            type="primary"
            size="small"
            class="btn mt10"
            @click="updateShop"
            >变更门店</el-button
          >
          <div class="switch-div mt10">
            <div class="title">设置我要核销月结权限</div>
            <div class="flex flex-center item-center">
              <el-switch
                v-model="monthlyStatementFlag"
                active-text=""
                inactive-text=""
                active-color="#2FC348"
                active-value="yes"
                inactive-value="no"
                class="mt10"
                @change="changeMonthlyStatementFlag()"
              ></el-switch>
            </div>
          </div>
          <div class="switch-div mt10">
            <div class="title">设置我要核销申报权限</div>
            <div class="flex flex-center item-center">
              <el-switch
                v-model="basicInfo.deny_flag"
                active-text=""
                inactive-text=""
                active-color="#2FC348"
                active-value="no"
                inactive-value="yes"
                class="mt10"
                @change="changeGuiderDeclareState()"
              ></el-switch>
            </div>
          </div>
        </div>
      </div>
      <div class="right-wrapper flex-1">
        <div class="topType-div">
          <el-radio-group
            size="small"
            v-model="topType"
            @change="switchTopType"
          >
            <el-radio-button label="info">导购信息</el-radio-button>
            <el-radio-button label="bill">导购账单</el-radio-button>
          </el-radio-group>
        </div>
        <div v-if="topType === 'info'">
          <div class="p30 right-info">
            <div class="flex item-center">
              <div class="right-info-title">已加入品牌</div>
              <div class="right-info-text">
                {{ memberInfo.hasJoinBrand }}
              </div>
            </div>
            <div class="flex item-center mt20">
              <div class="right-info-title">所属商户</div>
              <div class="right-info-text" @click="goAct">{{ memberInfo.storeName }}</div>
              <div class="right-info-title">加入时间</div>
              <div class="right-info-text">{{ basicInfo.join_time }}</div>
              <el-button
                type="primary"
                size="small"
                class="btn ml20"
                @click="changeRecord"
                >变更记录 | 查看</el-button
              >
              <el-button
                type="success"
                size="small"
                class="btn ml20"
                @click="changeBlackWhiteRecord"
                >黑白名单状态 | 变更记录</el-button
              >
            </div>
            <div class="flex item-center mt20">
              <div class="right-info-title">所属门店</div>
              <div class="right-info-text flex item-center">
                {{ memberInfo.shopName }}
                <div
                  class="tips"
                  v-if="
                    basicInfo.shopMonthlyStatementFlag &&
                    basicInfo.shopMonthlyStatementFlag !== '非月结门店'
                  "
                >
                  月结门店
                </div>
              </div>
              <div class="right-info-title">门店地址</div>
              <div class="right-info-text">
                {{ memberInfo.shopAddress }}
              </div>
              <el-button
                type="primary"
                size="small"
                class="btn ml20"
                @click="showMap(memberInfo.shopAddress)"
                >地图查看</el-button
              >
            </div>
            <div class="flex mt20">
              <div class="right-info-title">门头照片</div>
              <div v-if="memberInfo.workCardImg">
                <el-image
                  :src="memberInfo.workCardImg"
                  :preview-src-list="[memberInfo.workCardImg]"
                  class="shopImg"
                >
                </el-image>
              </div>
              <div v-else>暂无图片</div>
              <div class="right-info-title">小票照片</div>
              <div v-if="memberInfo.outletImg">
                <el-image
                  :src="memberInfo.outletImg"
                  :preview-src-list="[memberInfo.outletImg]"
                  class="shopImg"
                >
                </el-image>
              </div>
              <div v-else>暂无图片</div>
            </div>
          </div>
          <div class="flex">
            <div class="right-info-encryption mt20">
              <div class="flex">
                <div class="item flex">
                  <div class="title flex"><span class="in">实名信息</span></div>
                  <div class="text flex item-center">
                    <span class="ml20">身份证号</span>
                    <span class="ml20">{{ basicInfo.idcard_no }}</span>
                  </div>
                  <span
                    class="tips ml10"
                    v-if="basicInfo.idcard_let_audit_state === 'yes'"
                    >已通过认证</span
                  >
                </div>
                <div class="item flex ml10">
                  <div class="title flex">
                    <span class="in">身份证照片</span>
                  </div>
                  <div class="flex item-center">
                    <el-button
                      type="primary"
                      size="small"
                      class="ml10"
                      v-if="basicInfo.idcard_front_img"
                      @click="showImg(basicInfo.idcard_front_img)"
                      >人像面照片</el-button
                    ><el-button
                      type="primary"
                      size="small"
                      class="ml10"
                      v-if="basicInfo.idcard_back_img"
                      @click="showImg(basicInfo.idcard_back_img)"
                      >国徽面照片</el-button
                    >
                  </div>
                  <span
                    class="tips ml10"
                    v-if="basicInfo.idcard_img_audit_state === 'yes'"
                    >已通过认证</span
                  >
                </div>
                <div class="flex item-center">
                  <el-button
                    type="primary"
                    size="small"
                    class="btn ml20"
                    @click="changeIDCardRecord"
                    >实名记录 | 查看</el-button
                  >
                </div>
              </div>
              <div class="flex flex-between mt20">
                <div class="item flex">
                  <div class="title flex"><span class="in">收款信息</span></div>
                  <div>
                    <div class="flex flex-between h50">
                      <div class="text flex item-center">
                        <span class="ml20">支付宝账号：</span>
                        <span class="ml10">{{ basicInfo.alipay_account }}</span>
                      </div>
                      <span class="tips ml10" v-if="basicInfo.alipay_account"
                        >已通过认证</span
                      >
                    </div>
                    <div
                      class="flex flex-between h50"
                      v-for="(v, i) in bankInfoList"
                      :key="i"
                      @click="bankRecord(v.bank_card_number)"
                    >
                      <div class="text flex item-center">
                        <span class="ml20">银行卡账号{{ i + 1 }}：</span>
                        <span class="ml10">{{ v.bank_card_number }}</span>
                        <span class="ml20">手机号：</span>
                        <span class="ml10">{{ v.bank_save_mobile }}</span>
                      </div>
                      <div>
                        <span
                          class="tips ml10 float-right"
                          :class="{
                            danger: v.bank_save_mobile_verify_state !== 'yes',
                          }"
                          >{{ v.bind_state }}</span
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex item-end">
                  <el-button
                    type="primary"
                    size="small"
                    class="btn ml20"
                    @click="queryThirdContract"
                    >签约记录 | 查看</el-button
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="p30" v-else>
            <hm-guider-bill
              ref="HmGuiderBill"
              :customerId="customerId"
              @checkAll="checkAllEvent"
            ></hm-guider-bill>
          <div class="flex mt20">
            <el-button
              type="primary"
              size="small"
              class="btn mr20"
              @click="detailsDaoGou"
              >导购账单</el-button
            >
            <el-button
              type="primary"
              size="small"
              class="btn mr20"
              @click="goFlowList"
              >资金流水</el-button
            >
            <el-button
              type="primary"
              size="small"
              class="btn mr20"
              @click="detailsWithdraw"
              >提现账单</el-button
            >
          </div>
        </div>
      </div>

      <el-dialog
        title="实名记录"
        :visible="changeIDCardVisible"
        @close="changeIDCardVisible = false"
        custom-class="sales-volumn-dialog"
        width="1200px"
      >
        <div>
          <el-table
            stripe
            border
            :data="changeIDCardList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              :index="
                (index) => index + (currentPageIDCard - 1) * pageSizeIDCard + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="operateTime"
              label="时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="applyType"
              label="类型"
            >
              <template slot-scope="scope">
                <span
                  v-if="scope.row.operateType === 'guider_auth_identity_info'"
                  >实名认证</span
                >
                <span
                  v-if="scope.row.operateType === 'guider_cancel_identity_info'"
                  >注销认证</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="idcardName"
              label="认证后姓名"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.operateMemo).idcardName }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="idcardNo"
              label="认证后身份证"
            >
              <template slot-scope="scope">
                {{ JSON.parse(scope.row.operateMemo).idcardNo }}
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="totalIDCard"
              @current-change="pagingIDCard"
              @size-change="handleSizeChangeIDCard"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPageIDCard"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="变更记录"
        :visible="changeShopVisible"
        @close="changeShopVisible = false"
        custom-class="sales-volumn-dialog"
        width="1200px"
      >
        <div>
          <el-table
            stripe
            border
            :data="changeShopList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              :index="
                (index) => index + (currentPageShop - 1) * pageSizeShop + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="orderSn"
              label="申请状态"
            >
              <template slot-scope="scope">
                <span class="success" v-if="scope.row.auditState === 'agree'"
                  >同意</span
                >
                <span class="danger" v-if="scope.row.auditState === 'refuse'"
                  >拒绝</span
                >
                <span class="blue" v-if="scope.row.auditState === 'wait'"
                  >待审核</span
                >
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="applyType"
              label="申请类型"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.applyType === 'reg'">导购注册</span>
                <span v-if="scope.row.applyType === 'switch'">切换门店</span>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="guiderName"
              label="注册名"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="guiderPhone"
              label="绑定电话"
            ></el-table-column>

            <el-table-column
              header-align="center"
              align="center"
              prop="storeName"
              label="商户"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="shopName"
              label="门店"
            ></el-table-column>
            <!-- <el-table-column
                header-align="center"
                align="center"
                prop="receiptShopName"
                label="其他门店"
              ></el-table-column> -->
            <el-table-column
              header-align="center"
              align="center"
              prop="declareTime"
              label="申请时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="refuseReason"
              label="驳回原因"
            >
              <template slot-scope="scope">
                <div class="danger">
                  {{ scope.row.refuseReason }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="auditTime"
              label="审核时间"
            >
              <template slot-scope="scope">
                {{ scope.row.auditTime }}
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="auditUsername"
              label="审核人"
            ></el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="totalShop"
              @current-change="pagingShop"
              @size-change="handleSizeChangeShop"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPageShop"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="黑白名单状态/变更记录"
        :visible="changeBlackWhiteVisible"
        @close="changeBlackWhiteVisible = false"
        custom-class="sales-volumn-dialog"
        width="1200px"
      >
        <div>
          <el-table
            stripe
            border
            :data="blackWhiteList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              :index="
                (index) =>
                  index + (currentPageBlackWhite - 1) * pageSizeBlackWhite + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="operateType"
              label="变更类型"
            >
              <template slot-scope="scope">
                <div v-if="JSON.parse(scope.row.operateMemo).isWhite === true">
                  白名单
                </div>
                <div
                  v-else-if="
                    JSON.parse(scope.row.operateMemo).isWhite === false
                  "
                >
                  黑名单
                </div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="operateName"
              label="操作人"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="变更时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="refuseReason"
              label="变更原因"
            >
              <template slot-scope="scope">
                <div>{{ JSON.parse(scope.row.operateMemo).refuseReason }}</div>
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="refuseReasonVoucher"
              label="操作凭证"
            >
              <template slot-scope="scope">
                <a
                  :href="JSON.parse(scope.row.operateMemo).refuseReasonVoucher"
                  target="_blank"
                  ><div>
                    {{ JSON.parse(scope.row.operateMemo).refuseReasonVoucher }}
                  </div></a
                >
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
              background
              :total="totalblackWhite"
              @current-change="pagingBlackWhite"
              @size-change="handleSizeChangeBlackWhite"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPageBlackWhite"
            ></el-pagination>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="修改门店"
        :visible="detailsShop"
        @close="detailsShop = false"
        custom-class="sales-volumn-dialog"
      >
        <el-form
          label-width="100px"
          :model="ruleFormShop"
          :rules="rulesShop"
          ref="ruleFormShop"
        >
          <el-form-item label="选择商户" prop="storeCode">
            <el-select
              :disabled="allMerchant.length === 0"
              style="width: 300px"
              size="small"
              clearable
              placeholder="请选择商户"
              v-model="ruleFormShop.storeCode"
              class="mr10"
              filterable
              remote
              :remote-method="remoteMethod"
              @change="queryShop"
            >
              <el-option
                v-for="item in storeBasicList"
                :key="item.storeCode"
                :disabled="shopList.length === 0"
                :label="item.storeName"
                :value="item.storeCode"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="选择门店" prop="shopId">
            <el-select
              class="mr10"
              size="small"
              filterable
              v-model="ruleFormShop.shopId"
              placeholder="请选择门店"
            >
              <el-option
                :label="v.shopName"
                :value="v.shopId"
                v-for="(v, i) in shopList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer flex flex-center">
          <el-button
            @click="editShop('ruleFormShop')"
            size="small"
            type="primary"
            >确认</el-button
          >
          <el-button @click="detailsShop = false" size="small">关闭</el-button>
        </span>
      </el-dialog>
      <el-dialog
        title="银行卡绑定记录"
        :visible="bankRecordListVisible"
        @close="bankRecordListVisible = false"
        custom-class="sales-volumn-dialog"
        width="1200px"
      >
        <div>
          <el-table
            stripe
            border
            :data="bankRecordList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              :index="
                (index) =>
                  index + (currentPageBlackWhite - 1) * pageSizeBlackWhite + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="bank_card_number"
              label="账号"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="bank_name"
              label="银行卡名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="create_time"
              label="操作时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="del_flag"
              label="delFlag"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="bind_state"
              label="操作行为"
            ></el-table-column>
          </el-table>
          <!-- <div class="hm-pagination">
            <el-pagination
              background
              :total="totalblackWhite"
              @current-change="pagingBlackWhite"
              @size-change="handleSizeChangeBlackWhite"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPageBlackWhite"
            ></el-pagination>
          </div> -->
        </div>
      </el-dialog>
      <el-dialog
        title="银行卡绑定记录"
        :visible="bankRecordListVisible"
        @close="bankRecordListVisible = false"
        custom-class="sales-volumn-dialog"
        width="1200px"
      >
        <div>
          <el-table
            stripe
            border
            :data="bankRecordList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              :index="
                (index) =>
                  index + (currentPageBankRecord - 1) * pageSizeBankRecord + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="bank_card_number"
              label="账号"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="bank_name"
              label="银行卡名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="create_time"
              label="操作时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="del_flag"
              label="delFlag"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="bind_state"
              label="操作行为"
            ></el-table-column>
          </el-table>
          <!-- <div class="hm-pagination">
            <el-pagination
              background
              :total="totalBankRecord"
              @current-change="pagingBankRecord"
              @size-change="handleSizeChangeBankRecord"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPageBankRecord"
            ></el-pagination>
          </div> -->
        </div>
      </el-dialog>
      <el-dialog
        title="签约记录"
        :visible="thirdContractListVisible"
        @close="thirdContractListVisible = false"
        custom-class="sales-volumn-dialog"
        width="1200px"
      >
        <div>
          <el-table
            stripe
            border
            :data="thirdContractList"
            style="width: 100%"
            id="table"
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              :index="
                (index) =>
                  index +
                  (currentPageThirdContract - 1) * pageSizeThirdContract +
                  1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="company_name"
              label="签约平台"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="create_time"
              label="签约时间"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="third_customer_id"
              label="三方客户ID"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="register_state"
              label="签约状态"
            ></el-table-column>
          </el-table>
          <!-- <div class="hm-pagination">
            <el-pagination
              background
              :total="totalThirdContract"
              @current-change="pagingThirdContract"
              @size-change="handleSizeChangeThirdContract"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentPageThirdContract"
            ></el-pagination>
          </div> -->
        </div>
      </el-dialog>
      <el-dialog
        title="填写黑白名单原因"
        :visible="blackGuiderVisible"
        @close="blackReasonClose"
        width="30%"
      >
        <div class="mb20">
          <el-switch
            size="mini"
            v-model="isWhite"
            active-text="白名单"
            inactive-text="黑名单"
            active-color="#2fc348"
            inactive-color="#ff0000"
          ></el-switch>
        </div>
        <div class="mb10 flex flex-between item-center">
          <el-input
            clearable
            v-model.trim="refuseReason"
            placeholder="请填写黑白名单原因"
            style="width: 360px"
            type="textarea"
            :rows="6"
          ></el-input>
         
        </div>
        <div>
          <el-upload
            class="flex"
            ref="eluploadMainPic"
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onSuccess="uploadMainPicSucc2"
            :beforeUpload="beforeUpload"
            :show-file-list="uploadShow"
          >
            <div class="flex upload-upload-btn">
              <div
                class="btn flex flex-column flex-center open-file"
                @click="toggleShowRefuseReasonVoucher"
                v-if="!refuseReasonVoucher"
              >
                <div class="add-wrapper flex flex-center">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span>上传凭证</span>
              </div>
              <div
                v-if="refuseReasonVoucher"
                class="priviewbgp2 mr10 flex item-end"
              >
                <img :src="refuseReasonVoucher" alt="背景图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="deleteShowRefuseReasonVoucher"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </el-upload>
        </div>
         <span slot="footer" class="dialog-footer flex flex-center mt20">
             <el-button
            @click="isWhiteChange"
            size="small"
            type="primary"
            style="width: 80px; height: 30px"
          >
            确 定</el-button
          >
          </span>
      </el-dialog>
      <el-dialog
        :title="title"
        :close-on-click-modal="false"
        :visible.sync="dialogVisible"
        width="75%"
      >
        <div v-if="type === 'withdraw'">
          <div class="modal-table mb20">
            <div class="table-header flex">
              <div class="flex-1">姓名</div>
              <div class="flex-1">电话</div>
              <div class="flex-1">身份证号</div>
            </div>
            <div class="table-body flex">
              <div class="flex-1">
                {{ basicInfo.idcard_name || basicInfo.guider_name }}
              </div>
              <div class="flex-1">{{ basicInfo.auth_mobile }}</div>
              <div class="flex-1">{{ basicInfo.idcard_no }}</div>
            </div>
          </div>
          <div class="table-panel flex flex-end">
            <div class="flex-1 text-right">
              <el-input
                clearable
                style="width: 200px"
                v-model.trim="withdrawConditions.getcashSn"
                placeholder="请输入提现单号"
                size="small"
                class="ipt mr10"
              ></el-input>
              <el-date-picker
                v-model="withdrawConditions.getcachApplyTime"
                type="datetimerange"
                align="right"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="选择申请时间段"
                end-placeholder="选择申请时间段"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                clearable
              ></el-date-picker>
              <el-date-picker
                v-model="withdrawConditions.auditTime"
                type="datetimerange"
                align="right"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="选择审核时间段"
                end-placeholder="选择审核时间段"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                clearable
              ></el-date-picker>

              <el-button
                type="primary"
                size="small"
                @click="queryWithDrawOrderList"
                >查询</el-button
              >
              <el-button
                type="success"
                size="small"
                @click="
                  output('queryAllWithDrawOrderList', '提现账单', 'tableTx')
                "
                :loading="isOutputing"
                >导出</el-button
              >
            </div>
          </div>
          <div class="table">
            <el-table
              stripe
              border
              :data="widthDrawList"
              size="small"
              ref="tableTx"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="getcashSn"
                label="提现单号"
              >
                <template slot-scope="scope">
                  {{ scope.row.getcashSn }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="getcachApplyTime"
                label="申请时间"
              >
                <template slot-scope="scope">
                  {{ scope.row.getcachApplyTime }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditTime"
                label="审核时间"
              >
                <template slot-scope="scope">
                  {{ scope.row.auditTime }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="auditUsername"
                label="审核人"
              >
                <template slot-scope="scope">
                  {{ scope.row.auditUsername }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="提现金额"
                prop="getcashMoney"
              >
                <template slot-scope="scope">
                  <span class="primary">￥{{ scope.row.getcashMoney }}</span>
                </template>
              </el-table-column>
            </el-table>

            <div class="hm-pagination">
              <el-pagination
                background
                :total="widthDrawListTotal"
                @current-change="withDrawpaging"
                @size-change="handleWithDrawSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="withdrawCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div v-if="type === 'daoGou'">
          <div class="modal-table mb20">
            <div class="table-header flex">
              <div class="flex-1">姓名</div>
              <div class="flex-1">电话</div>
              <div class="flex-1">身份证号</div>
            </div>
            <div class="table-body flex">
              <div class="flex-1">
                {{ basicInfo.idcard_name || basicInfo.guider_name }}
              </div>
              <div class="flex-1">{{ basicInfo.auth_mobile }}</div>
              <div class="flex-1">{{ basicInfo.idcard_no }}</div>
            </div>
          </div>
          <div class="table-panel flex flex-between">
            <div>
              <el-radio-group
                v-model="auditState"
                size="small"
                @change="subjectTypeChange"
              >
                <el-radio-button label="agree">收益</el-radio-button>
                <el-radio-button label="refund">退款</el-radio-button>
              </el-radio-group>
            </div>
            <div class="flex-1 text-right">
              <el-date-picker
                v-model="declareTime"
                type="datetimerange"
                align="right"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="选择上传时间段"
                end-placeholder="选择上传时间段"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                clearable
              ></el-date-picker>
              <el-button
                type="primary"
                size="small"
                @click="queryGuiderOrderList"
                >查询</el-button
              >
              <el-button
                v-if="auditState === 'agree'"
                type="success"
                size="small"
                @click="
                  output('queryAllGuiderOrderList', '导购收益账单', 'tableDg')
                "
                :loading="isOutputing"
                >导出</el-button
              >
              <el-button
                v-if="auditState === 'refund'"
                type="success"
                size="small"
                @click="
                  output('queryAllGuiderOrderList', '导购退款账单', 'tableDg')
                "
                :loading="isOutputing"
                >导出</el-button
              >
            </div>
          </div>
          <div class="table">
            <el-table
              key="receiptId"
              stripe
              border
              :data="guiderList"
              ref="tableDg"
              size="small"
              v-if="resetForm"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="refundSn"
                label="退款单号"
                v-if="auditState === 'refund'"
              >
                <template slot-scope="scope">
                  {{ scope.row.refundSn }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareSn"
                label="申报单号"
              >
                <template slot-scope="scope">
                  {{ scope.row.declareSn }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptSn"
                label="小票号"
              >
                <template slot-scope="scope">
                  {{ scope.row.receiptSn }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareTime"
                label="申报时间"
              >
                <template slot-scope="scope">
                  {{ scope.row.declareTime }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="receiptDate"
                label="小票日期"
              >
                <template slot-scope="scope">
                  {{ scope.row.receiptDate }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="销售商品数量"
              >
                <template slot-scope="scope">
                  {{ scope.row.goodsNum }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="redpackageMoney"
                :label="auditState === 'agree' ? '总计收益' : '总计退款'"
              >
                <template slot-scope="scope">
                  <span class="primary">
                    {{ auditState === "agree" ? "" : "-" }} ￥{{
                      scope.row.redpackageMoney
                    }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                label="操作"
                header-align="center"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button
                      size="small"
                      type="text"
                      @click="details(scope.row)"
                      >查看详情</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <div class="hm-pagination">
              <el-pagination
                background
                :total="guiderListTotal"
                @current-change="guiderPaging"
                @size-change="handleGuiderSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="guiderCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
        <div v-if="type === 'flowList'">
          <div class="modal-table mb20">
            <div class="table-header flex">
              <div class="flex-1">姓名</div>
              <div class="flex-1">电话</div>
              <div class="flex-1">身份证号</div>
            </div>
            <div class="table-body flex">
              <div class="flex-1">
                {{ basicInfo.idcard_name || basicInfo.guider_name }}
              </div>
              <div class="flex-1">{{ basicInfo.auth_mobile }}</div>
              <div class="flex-1">{{ basicInfo.idcard_no }}</div>
            </div>
          </div>
          <div class="table-panel flex flex-end">
            <div class="flex-1 text-right">
              <el-date-picker
                v-model="flowAuditTime"
                type="datetimerange"
                align="right"
                :default-time="['00:00:00', '23:59:59']"
                start-placeholder="选择时间段"
                end-placeholder="选择时间段"
                value-format="yyyy-MM-dd HH:mm:ss"
                size="small"
                class="mr10"
                clearable
              ></el-date-picker>
              <el-button
                type="primary"
                size="small"
                @click="queryGuiderFlowList"
                >查询</el-button
              >
            </div>
          </div>
          <div class="table">
            <el-table
              key="receiptId"
              stripe
              border
              :data="flowList"
              ref="tableDg"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="tradeTime"
                label="交易时间"
              >
                <template slot-scope="scope">
                  {{ scope.row.tradeTime }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="billSn"
                label="交易单号"
              >
                <template slot-scope="scope">
                  {{ scope.row.billSn }}
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="declareTime"
                label="交易类型"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.flowType == 'store_profit'"
                    >品牌奖励</span
                  >
                  <span v-else-if="scope.row.flowType == 'guider_refund'"
                    >退单</span
                  >
                  <span v-else-if="scope.row.flowType == 'store_share_refund'"
                    >分成退单</span
                  >
                  <span
                    v-else-if="
                      scope.row.flowType == 'corporate_store_profit' ||
                      scope.row.flowType == 'private_store_profit'
                    "
                    >商户管理费</span
                  >
                  <span v-else-if="scope.row.flowType == 'video_ad'"
                    >赠送收入</span
                  >
                  <span v-else>商城收益</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="tradeMoney"
                label="收支金额"
              >
                <template slot-scope="scope">
                  <span v-if="scope.row.tradeMode == 'in'">+</span
                  ><span v-else>-</span>{{ scope.row.tradeMoney }}
                </template>
              </el-table-column>
            </el-table>

            <div class="hm-pagination">
              <el-pagination
                background
                :total="flowListTotal"
                @current-change="flowListPaging"
                @size-change="handleFlowListSizeChange"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="flowListCurrentPage"
              ></el-pagination>
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="账单详情"
        :close-on-click-modal="false"
        :visible.sync="dialogDeclare"
        width="800px"
      >
        <div>
          <div class="modal-table mb20">
            <div class="table-header flex">
              <div class="flex-1">导购姓名</div>
              <div class="flex-1">电话</div>
              <div class="flex-1" v-if="auditState === 'agree'">申报单号</div>
              <div class="flex-1" v-else>退款单号</div>
              <div class="flex-1">申报日期</div>
              <div class="flex-1">小票日期</div>
            </div>
            <div class="table-body flex">
              <div class="flex-1">{{ guiderDetails.guiderName }}</div>
              <div class="flex-1">{{ guiderDetails.guiderPhone }}</div>
              <div class="flex-1" v-if="auditState === 'agree'">{{ guiderDetails.declareSn }}</div>
              <div class="flex-1" v-else>{{ guiderDetails.refundSn }}</div>
              <div class="flex-1">{{ guiderDetails.declareTime }}</div>
              <div class="flex-1">{{ guiderDetails.receiptTime }}</div>
            </div>
          </div>
          <div class="mb20 flex flex-wrap">
            <!-- <div
            style="width:100px;height:100px"
            class="mr10"
            v-for="(v, i) in guiderDetails.declareImgList"
            :key="i"
          >
            <img :src="v" alt style="width:100%" />
          </div> -->
            <template v-if="this.auditState === 'agree'">
              <el-image
                v-for="(v, i) in guiderDetails.declareImgList"
                :key="i"
                style="width: 100px; height: 100px"
                class="mr10"
                :src="v"
                :preview-src-list="guiderDetails.declareImgList"
              ></el-image>
            </template>
          </div>
          <div class="table" v-if="this.auditState === 'agree'">
            <el-table
              stripe
              border
              :data="billDetailsBoList"
              size="small"
              :span-method="objectSpanMethod"
            >
              <el-table-column
                header-align="center"
                align="center"
                prop="rewardName"
                label="活动名称"
                key="rewardName"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="品牌"
                key="brandName"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品"
                key="goodsName"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="销售商品数量"
                key="goodsNum"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="redpackageMoney"
                label="收益基数"
                key="redpackageMoney"
              >
                <template slot-scope="scope">
                  <span class="primary">{{
                    (scope.row.redpackageMoney / scope.row.goodsNum).toFixed(2)
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="tradeMoney"
                label="计算收益"
                key="tradeMoney"
              >
                <template slot-scope="scope">
                  <span class="primary">￥{{ scope.row.tradeMoney }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="flex flex-end mt10">
              总计提成:
              <span class="primary" style="fontsize: 18px"
                >￥{{ totalRedpackageMoney }}</span
              >
            </div>
          </div>
          <div class="table" v-if="this.auditState === 'refund'">
            <el-table stripe border :data="billDetailsBoList" size="small">
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsName"
                label="商品名称"
                key="goodsName"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="brandName"
                label="品牌"
                key="brandName"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="goodsNum"
                label="商品数量"
                key="goodsNum"
              ></el-table-column>

              <el-table-column
                header-align="center"
                align="center"
                prop="refundAmount"
                label="退款金额"
                key="refundAmount"
              >
                <template slot-scope="scope">
                  <span class="primary">-￥{{ scope.row.refundAmount }}</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="flex flex-end mt10">
              总计退款:
              <span class="primary" style="fontsize: 18px"
                >-￥{{ totalRedpackageMoney }}</span
              >
            </div>
          </div>
        </div>
      </el-dialog>
      <el-dialog
      :visible.sync="dialogAct"
      width="1000px"
      title="活动详情"
      :close-on-click-modal="false"
    >
      <div>
        <el-table
          stripe
          :data="actList"
          border
          size="small"
          style="width: 100%"
        >
          <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
            :index="index => index + (currentPageAct - 1) * pageSizeAct + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="store_name"
            label="供货商名称"
          >
          <template slot-scope="scope">
            <div class="blue pointer" @click="goShopManage(scope.row)">
              {{ scope.row.store_name }}
            </div>
          </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="reward_name"
            label="活动名称"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="reward_name"
            label="活动时间"
          >
            <template slot-scope="scope">
              {{ scope.row.reward_start_date }}至{{ scope.row.reward_end_date }}
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="150"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="actDetails(scope.row)"
                >详情</el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
            background
            :total="totalAct"
            @current-change="pagingAct"
            @size-change="handleSizeChangeAct"
            layout="total,sizes,  prev, pager, next, jumper"
            :current-page="currentPageAct"
          ></el-pagination>
        </div>
      </div>
      <el-dialog
        width="1000px"
        title="活动详情"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="flex flex-between mb10">
          <div class="flex-1">
            活动名称：{{ detailsSupplierBasicInfo.ruleInfo.rewardName }}
          </div>
          <div class="flex-1">
            活动下线：到期<span class="blue">{{
              detailsSupplierBasicInfo.ruleInfo.autoOfflineDaysLimt
            }}</span
            >天后自动下线
          </div>
          <div class="flex-1 flex flex-wrap">
            <div>
              适用时段：
            </div>

            <div
              class="flex flex-center blue"
              v-if="
                detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'general'
              "
            >
              {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                detailsSupplierBasicInfo.ruleInfo.rewardEndDate
              }}
            </div>
            <div
              class="flex flex-center blue"
              v-if="
                detailsSupplierBasicInfo.ruleInfo.dateConfigMode === 'special'
              "
            >
              <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'date'">
                {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                  detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                }}的每{{ detailsSupplierBasicInfo.ruleInfo.dateValue }}天
              </div>
              <div v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'week'">
                {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                  detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                }}的
                <span
                  v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                  :key="i"
                >
                  {{ i === 0 ? "" : "," }}每周{{ v }}</span
                >
              </div>
              <div
                v-if="detailsSupplierBasicInfo.ruleInfo.dateType === 'month'"
              >
                {{ detailsSupplierBasicInfo.ruleInfo.rewardStartDate }}至{{
                  detailsSupplierBasicInfo.ruleInfo.rewardEndDate
                }}的
                <span
                  v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.dateValue"
                  :key="i"
                >
                  {{ i === 0 ? "" : "," }}每月{{ v }}号</span
                >
              </div>
            </div>
          </div>
          <!-- <div class="flex-1">
          基础提成：
          <span
            v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
            class="primary"
          >
            ¥{{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}</span
          >
          <span v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'">
            {{ detailsSupplierBasicInfo.ruleInfo.rewardValue }}%</span
          >
        </div>
        <div class="flex-1">
          活动条件：参与该活动的商品每满
          <span class="blue">{{
            detailsSupplierBasicInfo.ruleInfo.rewardNumberLimit
          }}</span>
          件为一组计算活动
        </div> -->
        </div>
        <div class="flex flex-between mb10">
          <div class="flex-1">
            适配组织：{{ detailsSupplierBasicInfo.ruleInfo.departNames }}
          </div>
          <div class="flex-1 flex-wrap ">
            活动备注：{{ detailsSupplierBasicInfo.ruleInfo.rewardRemark }}
          </div>
        </div>

        <div class="title mb10">
          适用商户:
          <span
            class="blue"
            v-for="(v, i) in detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
            :key="i"
          >
            {{ i === 0 ? "" : "," }}{{ v }}</span
          >
        </div>

        <div class="title mb10">
        适配商户类型：{{
          detailsSupplierBasicInfo.ruleInfo.adapterStoreType == "month"
            ? "月结"
            : "普通"
        }}
      </div>
        <!-- <div class="table mb10">
        <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.applyStoreCodes"
          style="width: 100%"
          id="table"
          size="small"
          border
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="label"
            label="商户名称"
          >
            <template slot-scope="scope">
              {{ scope.row }}
            </template>
          </el-table-column>
        </el-table>
      </div> -->
        <div
          class="title mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed'"
        >
          活动类型：普通活动
         <span v-if="detailsSupplierBasicInfo.ruleInfo.distributionType === 'group'">(按组奖励)</span>
         <span v-if="detailsSupplierBasicInfo.ruleInfo.distributionType === 'item'">(按件奖励)</span>
      </div>
        <div
          class="title mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub'"
        >
          活动类型：差异活动
        </div>
        <div
        class="title mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'tiktokLikePas'"
      >
        活动类型：报名活动
      </div>
        <div
          class="title mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
        >
          活动类型：冲刺活动
        </div>
        <div class="title mb10">
          <span>活动规则：</span>
          <p
            v-if="
              detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' &&
              detailsSupplierBasicInfo.ruleInfo.upperLimitSwitch
            "
            class="rule-upperLimitSwitch"
            style="margin: 0"
          >
            <span>根据申报数量按照规则门槛匹配一次，当前活动最高奖励</span>
            <span class="money">{{
              detailsSupplierBasicInfo.ruleInfo.ruleRelModelList[
                detailsSupplierBasicInfo.ruleInfo.ruleRelModelList.length - 1
              ]["rewardValue"]
            }}</span>
            <span>元</span>
          </p>
      </div>
        <div
          class="table mb10"
           v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' && detailsSupplierBasicInfo.ruleInfo.distributionType === 'group'"
        >
          <el-table
            stripe
            ref="roleTable"
            :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
            style="width: 500px"
            border
            id="table"
            size="small"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="每组件数"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                每满{{ scope.row.rewardNumberLimit }}件为一组
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="每组额外奖励"
              prop="rewardValue"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardValue }}元
              </template>
            </el-table-column>
            <el-table-column
            header-align="center"
            align="center"
            v-if="
              detailsSupplierBasicInfo.ruleInfo.requiredGoodsMode == 'true' ||
              detailsSupplierBasicInfo.ruleInfo.requiredGoodsMode == 'yes'
            "
            label="限制数量"
            prop="rewardRequiredNum"
          >
            <template slot-scope="scope">
              {{ scope.row.rewardRequiredNum }}件
            </template>
          </el-table-column>
          </el-table>
        </div>
        <div v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' && detailsSupplierBasicInfo.ruleInfo.distributionType == 'item'">按件奖励规则：以申报件数匹配最高等级X单件金额</div>
        <div
        class="table mb10"
        v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' && detailsSupplierBasicInfo.ruleInfo.distributionType === 'item'"
      >
      <el-table
          stripe
          ref="roleTable"
          :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
          style="width: 500px"
          border
          id="table"
          size="small"
          max-height="500px"
        >
          <el-table-column type="index" label="序号"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="数量"
            prop="rewardNumberLimit"
          >
            <template slot-scope="scope">
              当数量大于等于{{ scope.row.rewardNumberLimit }}件时
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="每件奖励"
            prop="rewardValue"
          >
            <template slot-scope="scope">
             每件按{{ scope.row.rewardValue }}元发放
            </template>
          </el-table-column>
        </el-table>
          <div class="flex-1 flex item-center mt10" v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'fixed' && detailsSupplierBasicInfo.ruleInfo.distributionType === 'item'">
            奖励上限(元)
              <el-input
                readonly
                size="small"
                style="width: 180px;margin-left:10px"
                v-model="detailsSupplierBasicInfo.ruleInfo.maxDistributionAmount"
              ></el-input>
          </div>
      </div>
      <div
        class="table mb10"
        v-if="
          detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub' ||
          detailsSupplierBasicInfo.ruleInfo.rewardMode === 'tiktokLikePas'
        "
      >
          <el-table
            :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
            style="width: 100%"
            ref="table"
            stripe
            size="small"
            :show-header="showHeader"
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="start"
              label="每组件数"
              width="700"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                买
                {{ scope.row.rewardNumberLimit }}
                件, 送
                {{ scope.row.rewardSubNum }}
                件,{{
                  new Number(scope.row.rewardNumberLimit) +
                    new Number(scope.row.rewardSubNum)
                }}件为一组，发放
                {{ scope.row.rewardNumberLimit }}件商品的单件奖励, 每组额外奖励
                {{ scope.row.rewardValue }}
                元
              </template>
            </el-table-column>

            <!-- <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <div>
                    <el-button
                      v-if="scope.$index === 0"
                      size="small"
                      @click="addChild(scope.$index)"
                      type="text"
                      >新 增</el-button
                    >
                    <el-button
                      v-else
                      size="small"
                      @click="delRule(scope.$index)"
                      class="danger"
                      type="text"
                      >删 除</el-button
                    >
                  </div>
                </template>
              </el-table-column> -->
          </el-table>
        </div>
        <div
          class="table mb10"
          v-if="detailsSupplierBasicInfo.ruleInfo.rewardMode === 'radio'"
        >
          <el-table
            stripe
            ref="roleTable"
            :data="detailsSupplierBasicInfo.ruleInfo.ruleRelModelList"
            style="width: 500px"
            border
            id="table"
            size="small"
          >
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="冲刺门槛"
              prop="rewardNumberLimit"
            >
              <template slot-scope="scope">
                {{ scope.row.rewardNumberLimit }}件
              </template>
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="额外奖励"
              prop="rewardValue"
            >
              <template slot-scope="scope">
                每件额外奖励{{ scope.row.rewardValue }}元
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="title mb10">
          适用商品
        </div>
        <div class="table mb10">
          <el-table
            stripe
            ref="roleTable"
            :data="detailsSupplierBasicInfo.goodsList"
            style="width: 100%"
            id="table"
            size="small"
            border
          >
            <el-table-column
              type="index"
              label="序号"
              header-align="center"
              align="center"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="brandName"
              label="商品品牌"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsName"
              label="商品名称"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="goodsBarcode"
              label="商品条码"
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              prop="rewardBaseMoney"
              label="单件奖励"
              v-if="
              detailsSupplierBasicInfo.ruleInfo.rewardMode === 'sub' ||
              detailsSupplierBasicInfo.ruleInfo.rewardMode === 'tiktokLikePas'
            "
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="flex flex-center">
          <el-button size="small" type="primary" @click="innerVisible = false"
            >确认</el-button
          >
        </div>
      </el-dialog>
    </el-dialog>
    </div>
      <el-dialog
        title="填写我要核销申报权限原因"
        :visible="declareGuiderVisible"
        @close="blackReasonClose"
        width="30%"
      >
        <div class="mb10 flex flex-between item-center">
          <el-input
            clearable
            v-model.trim="refuseReason"
            placeholder="请填写变更原因"
            style="width: 360px"
            type="textarea"
            :rows="6"
          ></el-input>
         
        </div>
        <div>
          <el-upload
            class="flex"
            ref="eluploadMainPic"
            :data="{ fileDir: 'mall' }"
            :headers="{ 'X-Access-Token': $token }"
            :action="$uploadUrl"
            :onSuccess="uploadMainPicSucc2"
            :beforeUpload="beforeUpload"
            :show-file-list="uploadShow"
          >
            <div class="flex upload-upload-btn">
              <div
                class="btn flex flex-column flex-center open-file"
                @click="toggleShowRefuseReasonVoucher"
                v-if="!refuseReasonVoucher"
              >
                <div class="add-wrapper flex flex-center">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span>上传凭证</span>
              </div>
              <div
                v-if="refuseReasonVoucher"
                class="priviewbgp2 mr10 flex item-end"
              >
                <img :src="refuseReasonVoucher" alt="背景图" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="deleteShowRefuseReasonVoucher"
                    >删除</el-button
                  >
                </div>
              </div>
            </div>
          </el-upload>
        </div>
         <span slot="footer" class="dialog-footer flex flex-center mt20">
             <el-button
            @click="saveGuiderDeclareState"
            size="small"
            type="primary"
            style="width: 80px; height: 30px"
          >
            确 定</el-button
          >
          </span>
      </el-dialog>
       <el-dialog
          title="选择供应商品牌"
          :visible="supplierBrand"
          @close="supplierBrand = false"
          width="500px"
          custom-class="sales-volumn-dialog"
        >
          <div class="mb20" v-for="item in supplierBrandList" :key="item.supplierCode">
            <div class="flex item-center flex-between">
                  <el-checkbox v-model="item.checked">
                    <span style="fontWeight: bold;">{{item.supplierName}}</span>
                  </el-checkbox>
                    <i :class="item.checked?'el-icon-arrow-down':'el-icon-arrow-right'"></i>
            </div>
            <div class="ml20" v-if="item.checked">
               <div class="mt10" v-for="(info,index) in item.brandInfoList" :key="index">
                  {{info.brandName}}
              </div>
            </div>
          </div>
          <div style="width: 100px;margin: 20px auto;text-align: center;" v-if="supplierBrandList.length == 0">暂无数据</div>

          <span slot="footer" class="dialog-footer flex item-center flex-between">
            <div>
              已选择{{checkedSupplierBrandAll.length}}个品牌
            </div>
            <div>
                <el-button
                @click="affirmSupplierBrand"
                size="small"
                type="primary"
                >确认</el-button
              >
              <el-button @click="supplierBrand = false" size="small"
                >关闭</el-button
              >
            </div>
            
          </span>
        </el-dialog>
  </hm-content>
</template>
<script>
import { mapGetters } from "vuex";
import * as XLSX from "xlsx/xlsx";
import { getCookie, setCookie, ToFixed } from "@/utils/utils";
import moment from "moment";
import HmGuiderBill from "@/components/HmGuiderBill";
let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串

export default {
  components: {HmGuiderBill},
  data() {
    return {
      ToFixed,
      defaultAvatar:
        "https://imgcdn.hemiao100.com/commission/06958ea63491a6c01af00f4b7d7c9aa.png",
      headerImg:
        "https://imgcdn.hemiao100.com/42010216070190/goods/1672044911617-2c559dd8-2ec7-46ad.jpg?x-oss-process=image/auto-orient,1",
      shopImg:
        "https://imgcdn.hemiao100.com/42010216070190/goods/1672044911617-2c559dd8-2ec7-46ad.jpg?x-oss-process=image/auto-orient,1",
      receiptImg:
        "https://imgcdn.hemiao100.com/42010216070190/goods/1672044911617-2c559dd8-2ec7-46ad.jpg?x-oss-process=image/auto-orient,1",
      guiderState: "yes",
      guiderState2: "yes",
      topType: "info",
      changeIDCardVisible: false,
      totalIDCard: 0,
      currentPageIDCard: 1,
      pageSizeIDCard: 10,
      changeIDCardList: [],
      changeShopVisible: false,
      totalShop: 0,
      currentPageShop: 1,
      pageSizeShop: 10,
      changeShopList: [],
      blackWhiteList: [],
      totalblackWhite: 0,
      currentPageBlackWhite: 1,
      pageSizeBlackWhite: 10,
      changeBlackWhiteVisible: false,
      detailsShop: false,
      shopList: [],
      ruleFormShop: {
        shopId: "",
        storeCode: "",
      },
      rulesShop: {
        shopId: {
          required: true,
          message: "请选择门店!",
          trigger: "change",
        },
        storeCode: {
          required: true,
          message: "请选择商户!",
          trigger: "change",
        },
      },
      customerId: this.$route.query.customerId,
      guiderId: "",
      storeCode: "",
      roleType: "guider",
      memberInfo: {},
      allMerchant: [],
      storeBasicList: [],
      basicInfo: {},
      declareGuiderVisible:false,
      bankInfoList: [],
      bankRecordListVisible: false,
      bankRecordList: [],
      currentPageBankRecord: 1,
      pageSizeBankRecord: 10,
      thirdContractListVisible: false,
      thirdContractList: [],
      currentPageThirdContract: 1,
      pageSizeThirdContract: 10,
      isWhite: "",
      refuseReason: "",
      refuseReasonVoucher: "",
      showRefuseReasonVoucher: false,
      uploadShow: false,
      blackGuiderVisible: false,
      monthlyStatementFlag: "yes",
      title: "",
      dialogVisible: false,
      type: "",
      guiderList: [],
      guiderPageSize: 10,
      guiderCurrentPage: 1,
      guiderListTotal: 0,
      declareTime: [],
      auditState: "agree",
      isOutputing: false,
      flowListCurrentPage: 1,
      flowListPageSize: 10,
      flowListTotal: 0,
      flowAuditTime: [],
      flowList: [],
      withdrawPageSize: 10,
      withdrawCurrentPage: 1,
      widthDrawList: [],
      widthDrawListTotal: 0,
      withdrawConditions: {},
      dialogDeclare: false,
      guiderDetails: {},
      totalRedpackageMoney: 0,
      billDetailsBoList: [],
      checkAll: undefined,
      resetForm: true,
      waitNum: 0,
      handleNum: 0,
      innerVisible: false,
      totalAct: 0,
      currentPageAct: 1,
      pageSizeAct: 10,
      dialogAct: false,
      actList: [],
       // 选择供应商品牌
      supplierBrand:false,
      supplierBrandList: []
    };
  },
 computed: {
    ...mapGetters(["detailsSupplierBasicInfo"]),
    checkedSupplierBrandAll() {
      return this.supplierBrandList
        .filter(item => item.checked) // 筛选出 checked 为 true 的项
        .map(item => item.supplierCode); // 提取 supplierCode 组成新数组
    }
  },
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    async init() {
      await this.queryCustomerBasicInfo();
      await this.queryCustomerBankInfo();
      await this.detailsGuide();
      await this.queryNumInfo();
    },
    async queryCustomerBasicInfo() {
      let dynamicQueryCondition = {
        customerId: this.customerId,
      };
      let params = {
        dynamicQueryCondition: dynamicQueryCondition,
        reportCode: "QUERY_CUSTOMER_ARCHIVE_BASIC_INFO",
      };
      const { result } = await this.$store.dispatch(
        "queryCustomerInfo",
        params
      );
      if (result) {
        if (result.dataList) {
          this.basicInfo = result.dataList[0];
          this.guiderId = this.basicInfo.guider_id;
          this.storeCode = this.basicInfo.store_code;
          this.roleType = this.basicInfo.type;
          if (this.basicInfo.shopMonthlyStatementFlag !== "非月结门店") {
            this.monthlyStatementFlag = "yes";
          } else {
            this.monthlyStatementFlag = "no";
          }
          if (this.basicInfo.is_white === 0) {
            this.isWhite = false;
          } else {
            this.isWhite = true;
          }
        }
      }
    },
    async queryCustomerBankInfo() {
      let dynamicQueryCondition = {
        customerId: this.customerId,
      };
      let params = {
        dynamicQueryCondition: dynamicQueryCondition,
        reportCode: "QUERY_CUSTOMER_ARCHIVE_LAST_BANK_INFO",
      };
      const { result } = await this.$store.dispatch(
        "queryCustomerInfo",
        params
      );
      if (result) {
        if (result.dataList) {
          this.bankInfoList = result.dataList;
        }
      }
    },
    async bankRecord(bankCardNumber) {
      let dynamicQueryCondition = {
        customerId: this.customerId,
        bankCardNumber,
      };
      let params = {
        dynamicQueryCondition: dynamicQueryCondition,
        reportCode: "QUERY_CUSTOMER_ARCHIVE_BANK_CARD_NUMBER",
      };
      const { result } = await this.$store.dispatch(
        "queryCustomerInfo",
        params
      );
      if (result) {
        if (result.dataList) {
          this.bankRecordList = result.dataList;
        }
        this.bankRecordListVisible = true;
      }
    },
    async queryThirdContract() {
      let dynamicQueryCondition = {
        customerId: this.customerId,
      };
      let params = {
        dynamicQueryCondition: dynamicQueryCondition,
        reportCode: "QUERY_THIRD_CONTRACT_CUSTOMER_INFO",
      };
      const { result } = await this.$store.dispatch(
        "queryCustomerInfo",
        params
      );
      if (result) {
        if (result.dataList) {
          this.thirdContractList = result.dataList;
        }
        this.thirdContractListVisible = true;
      }
    },
    async detailsGuide() {
      const { result } = await this.$store.dispatch("queryRedPacketRoleInfo", {
        customerId: this.customerId,
        roleType: this.roleType,
      });
      this.memberInfo = result;
    },
    async queryNumInfo() {
      const { result } = await this.$store.dispatch("queryNumInfo", {
        guiderId: this.guiderId,
      });
      if (result) {
        this.waitNum = result.waitNum
        this.handleNum = result.handleNum
      }
    },
    switchTopType(e) {
      console.log("this.topType:", this.topType);
      if (e === "bill") {
        // this.$refs.HmGuiderBill.queryCustomerInfo(this.customerId);
      }
    },
    pagingIDCard(page) {
      this.currentPageIDCard = page;
      this.queryChangIDCardList();
    },
    handleSizeChangeIDCard(size) {
      this.currentPageIDCard = 1;
      this.pageSizeIDCard = size;
      this.queryChangIDCardList();
    },
    async queryChangIDCardList() {
      let params = {
        pageSize: this.pageSizeIDCard,
        pageNo: this.currentPageIDCard,
        operateTypeList: [
          "guider_auth_identity_info",
          "guider_cancel_identity_info",
        ],
        operateColumnValue: this.customerId,
      };
      const { result } = await this.$store.dispatch(
        "queryPageListByModel",
        params
      );
      const { records, total } = result;
      this.changeIDCardList = records;
      this.totalIDCard = total;
    },
    async changeIDCardRecord() {
      this.changeIDCardVisible = true;
      this.pageSizeIDCard = 10;
      this.currentPageIDCard = 1;
      this.queryChangIDCardList();
    },
    async changeRecord() {
      this.changeShopVisible = true;
      this.pageSizeShop = 10;
      this.currentPageShop = 1;
      this.queryChangShopList();
    },
    pagingShop(page) {
      this.currentPageShop = page;
      this.queryChangShopList();
    },
    handleSizeChangeShop(size) {
      this.currentPageShop = 1;
      this.pageSizeShop = size;
      this.queryChangShopList();
    },
    async queryChangShopList() {
      let params = {
        pageSize: this.pageSizeShop,
        pageNo: this.currentPageShop,
        guiderId: this.guiderId,
      };
      const { result } = await this.$store.dispatch("guiderOperate", params);
      const { records, total } = result;
      this.changeShopList = records;
      this.totalShop = total;
    },
    changeBlackWhiteRecord() {
      this.changeBlackWhiteVisible = true;
      this.pageSizeBlackWhite = 10;
      this.currentPageBlackWhite = 1;
      this.queryBlackWhiteList();
    },
    async queryBlackWhiteList() {
      let params = {
        pageSize: this.pageSizeBlackWhite,
        pageNo: this.currentPageBlackWhite,
        operateTypeList: ["edit_guider_white_list"],
        operateColumnValue: this.guiderId,
      };
      const { result } = await this.$store.dispatch(
        "queryPageListByModel",
        params
      );
      const { records, total } = result;
      this.blackWhiteList = records;
      this.totalblackWhite = total;
    },
    pagingBlackWhite(page) {
      this.currentPageBlackWhite = page;
      this.queryBlackWhiteList();
    },
    handleSizeChangeBlackWhite(size) {
      this.currentPageBlackWhite = 1;
      this.pageSizeBlackWhite = size;
      this.queryBlackWhiteList();
    },
    async updateShop() {
      this.queryAllMerchant();
      this.detailsShop = true;
      let params = {
        pageSize: 99999,
        pageNo: 1,
        storeCode: this.storeCode,
      };
      this.$store.dispatch("queryStoreShopInfoList", params).then((res) => {
        // this.shopList = res.result.records;
        this.shopList = res.result.records.filter(shop => shop.shopName !== this.memberInfo.shopName);
      });
    },
    async queryShop(storeCode) {
      this.shopList = [];
      this.ruleFormShop.shopId = "";
      let params = {
        pageSize: 99999,
        pageNo: 1,
        storeCode: storeCode,
      };
      this.$store.dispatch("queryStoreShopInfoList", params).then((res) => {
        // this.shopList = res.result.records;
         this.shopList = res.result.records.filter(shop => shop.shopName !== this.memberInfo.shopName);
      });
    },
    async editShop(ruleForm) {
      const vaild = await this.$refs[ruleForm].validate();
      if (vaild) {
        let params = {
          guiderId: this.guiderId,
          addSwitchShopRecord: "yes",
        };
        Object.assign(params, this.ruleFormShop);

        const { code } = await this.$store.dispatch(
          "guiderDeclareOperate",
          params
        );

        if (code === "0") {
          this.detailsShop = false;
          this.$message({
            message: "操作成功!",
            type: "success",
          });
          setTimeout(() => {
            this.resetRuleForm("ruleFormShop");
          }, 0);
          this.init();
        }
      }
    },
    resetRuleForm(ruleForm) {
      this.$refs[ruleForm].resetFields();
    },
    async queryAllMerchant() {
      const { result } = await this.$store.dispatch(
        "queryStoreBasicListComboBox"
      );
      this.allMerchant = result;
    },
    remoteMethod(query) {
      if (query !== "") {
        this.storeBasicList = this.allMerchant.filter(
          (v) => v.storeName.indexOf(query) > -1
        );
      } else {
        this.storeBasicList = [];
      }
    },
    showImg(img) {
      window.open(img, "_blank");
    },
    showMap(address) {
      let url = "https://apis.map.qq.com/uri/v1/search?keyword=" + address;
      window.open(url, "_blank");
    },
    changeMonthlyStatementFlag() {
      console.log("this.monthlyStatementFlag:", this.monthlyStatementFlag);
      if (this.monthlyStatementFlag === "yes") {
        this.monthlyStatementFlag = "no";
        // this.saveMonthlyStatementShop();
        this.guiderViewSupplierBrand()
      } else {
        this.monthlyStatementFlag = "yes";
        this.updateShop();
      }
    },
        // 查询供应商品牌
    guiderViewSupplierBrand() {
       this.supplierBrandList = []
       let params = {
          guiderId: this.guiderId,
       }
        this.$store.dispatch(
        "guiderViewSupplierBrand",
        params
      ).then(res => { 
          if(res.code == '0' && (res.result.supplierBrandList && res.result.supplierBrandList.length)) {
          //  this.supplierBrandList = res.result.supplierBrandList
          this.supplierBrandList = res.result.supplierBrandList.filter(
              item => item.guiderAllow === 'no'
            );
          }else {
            this.supplierBrandList = []
          }
           this.supplierBrand = true
        })
    },
       // 保存月结品牌
    affirmSupplierBrand() {
      if(this.checkedSupplierBrandAll.length) {
        let params = {
          // supplierCode:"",
          supplierCodeList: this.checkedSupplierBrandAll,
          guiderId: this.guiderId,
          useScene: "allowGuiderAutoAddSupplierBrand",
          configValue:"yes"

        }
        this.$store.dispatch(
        "hemiaoSetGuiderConfig",
        params
      ).then(res => { 
          if(res.code == '0') {
            this.saveMonthlyStatementShop();
            this.supplierBrand = false
          }
        })
      }else {
         this.saveMonthlyStatementShop();
      }
    },
    async saveMonthlyStatementShop() {
      let params = {
        guiderId: this.guiderId,
        storeCode: this.storeCode,
      };
      await this.$store.dispatch("saveMonthlyStatementShop", params);
      this.$message({
        message: "操作成功",
        type: "success",
      });
      this.supplierBrand = false
      this.init();
    },
    async changeGuiderDeclareState() {
      this.refuseReason = ''
      this.refuseReasonVoucher = ''
       if (this.basicInfo.deny_flag === "yes") {
        this.basicInfo.deny_flag = "no";
        this.declareGuiderVisible = true
      } else {
       this.basicInfo.deny_flag = "yes";
        this.declareGuiderVisible = true
      }
    //   let params = {
    //     guiderPhone: this.basicInfo.auth_mobile,
    //   };
    //   await this.$store.dispatch("changeGuiderDeclareState", params);
    //   this.$message({
    //     message: "操作成功",
    //     type: "success",
    //   });
    //   this.init();
    },
   async saveGuiderDeclareState() {
     if (this.refuseReason == '') {
        this.$message({
          message: "请输入原因",
          type: "warning"
        });
        return;
      }
      if (this.refuseReasonVoucher == '') {
        this.$message({
          message: "请上传凭证",
          type: "warning"
        });
        return;
      }
      let params = {
        guiderPhone: this.basicInfo.auth_mobile,
        operReason: this.refuseReason,
        operReasonVoucher: this.refuseReasonVoucher,
      };
      this.$store.dispatch("changeGuiderDeclareState", params).then((res) => {
        this.declareGuiderVisible = false;
        this.$message({
          message: " 操作成功",
          type: "success"
        });
         this.init();
      });
      // await this.$store.dispatch("changeGuiderDeclareState", params);
      // this.$message({
      //   message: "操作成功",
      //   type: "success",
      // });
      // this.init();
    },
    blackReasonClick() {
      this.refuseReason = "";
      this.refuseReasonVoucher = "";
      this.queryCustomerBasicInfo();
      this.blackGuiderVisible = true;
    },
    blackReasonClose() {
      this.blackGuiderVisible = false;
      this.declareGuiderVisible = false
      this.refuseReason = ''
      this.refuseReasonVoucher = ''
    },
    async isWhiteChange() {
       if (this.refuseReason == '') {
        this.$message({
          message: "请输入原因",
          type: "warning"
        });
        return;
      }
      if (this.refuseReasonVoucher == '') {
        this.$message({
          message: "请上传凭证",
          type: "warning"
        });
        return;
      }
      let params = {
        guiderId: this.guiderId,
        isWhite: this.isWhite,
        refuseReason: this.refuseReason,
        refuseReasonVoucher: this.refuseReasonVoucher,
      };
      this.$store.dispatch("managerGuiderEdit", params).then((res) => {
        this.blackGuiderVisible = false;
        this.$message({
          message: " 操作成功",
          type: "success"
        });
      });
    },
    toggleShowRefuseReasonVoucher() {
      this.showRefuseReasonVoucher = !this.showRefuseReasonVoucher;
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccessRefuseReasonVoucher(jsonData) {
      if (this.showRefuseReasonVoucher) {
        this.refuseReasonVoucher = jsonData.result;
      }
    },
    deleteShowRefuseReasonVoucher() {
      this.refuseReasonVoucher = "";
    },
    beforeUpload(file) {
      console.log("file: ", file);
      const extension =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
          "jpg" ||
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "gif";
      const extension2 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() ===
        "jpeg";
      const extension3 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "png";
      const extension4 =
        file.name.slice(file.name.lastIndexOf(".") + 1).toLowerCase() === "bmp";
      // file.size单位为b，除以1024得到kb
      //   const limitSize = file.size / 1024 <= 1020;
      if (!extension && !extension2 && !extension3 && !extension4) {
        this.$message({
          message: "上传模板只能是 jpg、jpeg、png、bmp格式!",
          type: "warning",
        });
      }
      //   if (!limitSize) {
      //     this.$message({
      //       message: "上传模板大小不能超过 1M!",
      //       type: "warning"
      //     });
      //   }
      return extension || extension2 || extension3 || extension4;
    },
    uploadMainPicSucc2(jsonData) {
      if (jsonData.code === 0) {
        this.refuseReasonVoucher = jsonData.result;
      }
    },
    detailsDaoGou() {
      this.title = "导购账单";
      this.type = "daoGou";
      this.auditState = "agree";
      this.guiderPageSize = 10;
      this.guiderCurrentPage = 1;
      this.dialogVisible = true;
      this.queryGuiderOrderList();
    },
    queryAllGuiderOrderList() {
      return this.$store.dispatch("queryAllGuiderOrderList", {
        auditState: this.auditState,
        guiderId: this.guiderId,
        pageSize: 99999,
        pageNo: this.guiderCurrentPage,
        declareStartTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[0]
            : "",
        declareEndTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[1]
            : "",
      });
    },
    async queryGuiderOrderList() {
      const { result } = await this.$store.dispatch("queryGuiderOrderList", {
        guiderId: this.guiderId,
        pageSize: this.guiderPageSize,
        pageNo: this.guiderCurrentPage,
        auditState: this.auditState,
        declareStartTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[0]
            : "",
        declareEndTime:
          this.declareTime && this.declareTime.length
            ? this.declareTime[1]
            : "",
      });
      const { records, total } = result;
      this.guiderList = records;
      this.guiderListTotal = total;
    },
    subjectTypeChange() {
      this.resetForm = false;
      this.$nextTick(() => {
        this.resetForm = true;
      });
      this.guiderPageSize = 10;
      this.guiderCurrentPage = 1;
      this.queryGuiderOrderList();
    },
    guiderPaging(page) {
      this.guiderCurrentPage = page;
      this.queryGuiderOrderList();
    },
    handleGuiderSizeChange(size) {
      this.guiderCurrentPage = 1;
      this.guiderPageSize = size;
      this.queryGuiderOrderList();
    },
    async goFlowList() {
      this.title = "资金流水";
      this.type = "flowList";
      this.dialogVisible = true;
      this.queryFlowList();
    },
    async queryFlowList() {
      let params = {
        pageNo: this.flowListCurrentPage,
        pageSize: this.flowListPageSize,
        customerId: this.customerId,
        auditStartTime:
          this.flowAuditTime && this.flowAuditTime.length
            ? this.flowAuditTime[0]
            : "",
        auditEndTime:
          this.flowAuditTime && this.flowAuditTime.length
            ? this.flowAuditTime[1]
            : "",
      };
      const { result } = await this.$store.dispatch(
        "queryGuiderFlowList",
        params
      );
      this.flowList = result.order.records;
      this.flowListTotal = result.order.total;
    },
    flowListPaging(page) {
      this.flowListCurrentPage = page;
      this.queryFlowList();
    },
    handleFlowListSizeChange(size) {
      this.flowListCurrentPage = 1;
      this.flowListPageSize = size;
      this.queryFlowList();
    },
    queryGuiderFlowList() {
      this.flowListCurrentPage = 1;
      this.queryFlowList();
    },

    withDrawpaging(page) {
      this.withdrawCurrentPage = page;
      this.queryWithDrawOrderList();
    },
    handleWithDrawSizeChange(size) {
      this.withdrawCurrentPage = 1;
      this.withdrawPageSize = size;
      this.queryWithDrawOrderList();
    },
    async detailsWithdraw() {
      this.title = "提现账单";
      this.type = "withdraw";
      this.dialogVisible = true;
      this.queryWithDrawOrderList();
    },
    async queryWithDrawOrderList() {
      let params = {
        customerId: this.customerId,
        pageNo: this.withdrawCurrentPage,
        pageSize: this.withdrawPageSize,
      };
      let conditions = JSON.parse(JSON.stringify(this.withdrawConditions));
      if (conditions.getcachApplyTime && conditions.getcachApplyTime.length) {
        conditions.getcachApplyStartTime = conditions.getcachApplyTime[0];
        conditions.getcachApplyEndTime = conditions.getcachApplyTime[1];
        delete conditions.getcachApplyTime;
      }
      if (conditions.auditTime && conditions.auditTime.length) {
        conditions.auditStartTime = conditions.auditTime[0];
        conditions.auditEndTime = conditions.auditTime[1];
        delete conditions.auditTime;
      }
      Object.assign(params, conditions);
      // withdrawConditions
      const { result } = await this.$store.dispatch(
        "queryWithDrawOrderList",
        params
      );
      const { records, total } = result;
      this.widthDrawList = records;
      this.widthDrawListTotal = total;
    },
    queryAllWithDrawOrderList() {
      let params = {
        customerId: this.customerId,
        pageNo: 1,
        pageSize: 999999,
      };
      let conditions = JSON.parse(JSON.stringify(this.withdrawConditions));
      if (conditions.getcachApplyTime && conditions.getcachApplyTime.length) {
        conditions.getcachApplyStartTime = conditions.getcachApplyTime[0];
        conditions.getcachApplyEndTime = conditions.getcachApplyTime[1];
        delete conditions.getcachApplyTime;
      }
      if (conditions.auditTime && conditions.auditTime.length) {
        conditions.auditStartTime = conditions.auditTime[0];
        conditions.auditEndTime = conditions.auditTime[1];
        delete conditions.auditTime;
      }
      Object.assign(params, conditions);
      return this.$store.dispatch("queryAllWithDrawOrderList", params);
    },
    // 导出excel
    output(funcName, title, table) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func()
          .then((res) => {
            const list = res.result.records;

            const tHeader = this.$refs[table].columns
              .map((o) => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter((o) => o);
            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs[table].$children
                .map((o) => o._props.prop)
                .filter((o) => o);
            }

            const data = this.formatJson(filterVal, list);
            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    async details(row) {
      this.dialogDeclare = true;
      let declareSn = "";
      if(this.auditState === 'agree' ){
        declareSn = row.declareSn
      }else{
        declareSn = row.refundSn
      }
      const { result } = await this.$store.dispatch("viewGuiderOrderDetails", {
        auditState: this.auditState,
        declareSn,
      });
      if (this.auditState === "agree") {
        this.totalRedpackageMoney = row.redpackageMoney;
        let list = [];
        result.rewardRuleInfoModelList.forEach((v) => {
          v.billDetailsBoList.forEach((j) => {
            j.rewardName = v.rewardName;
            j.tradeMoney = v.companyCapitalFlowModel.tradeMoney;
            list.push(j);
          });
        });

        this.billDetailsBoList = list;
        this.getRowSpan();
        this.guiderDetails = result;
      } else if (this.auditState === "refund") {
        this.guiderDetails = row;
        this.totalRedpackageMoney = result.totalRefundAmount;
        this.billDetailsBoList = result.refundBillDetailsModelList;
      }

      // this.guiderDetails.totalRedpackageMoney = 0;
      // this.guiderDetails.billDetailsBoList.forEach(v => {
      //   v.guiderName = this.guiderDetails.guiderName;
      //   this.guiderDetails.totalRedpackageMoney += v.redpackageMoney;
      // });

      // this.guiderDetails.declareImgList = this.guiderDetails.declareImg.split(
      //   ","
      // );
    },
    getRowSpan() {
      this.rowSpanArr = [];
      this.billDetailsBoList.forEach((item, index) => {
        if (index == 0) {
          this.rowSpanArr.push(1);
          this.position = 0;
        } else {
          if (
            this.billDetailsBoList[index].rewardRuleId ==
            this.billDetailsBoList[index - 1].rewardRuleId
          ) {
            this.rowSpanArr[this.position] += 1; //项目名称相同，合并到同一个数组中
            this.rowSpanArr.push(0);
            this.billDetailsBoList[index].rewardRuleId =
              this.billDetailsBoList[index - 1].rewardRuleId;
          } else {
            this.rowSpanArr.push(1);
            this.position = index;
          }
        }
      });
      this.billDetailsBoList = [...this.billDetailsBoList];
    },
    objectSpanMethod({ rowIndex, columnIndex }) {
      // 只合并区域位置

      if (columnIndex === 0 || columnIndex === 5) {
        const _row = this.rowSpanArr[rowIndex];

        return {
          rowspan: _row, //行
          colspan: 1 //列
        };
      }
    },
    checkAllEvent(data){
      this.checkAll = data;
      console.log("父组件this.checkAll:",this.checkAll);
    },
    billWait() {
      this.$router.push({
        name: "SalesVolume",
        query: {
          queryDay: 30,
          keyWord: this.basicInfo.auth_mobile,    
          tabPositionChild: 'personWait',      
        }
      });
    },
    billRefuse() {
      this.$router.push({
        name: "SalesVolume",
        query: {
          queryDay: 30,
          keyWord: this.basicInfo.auth_mobile,    
          tabPositionChild: 'refuse',      
        }
      });
    },
    goAct() {
      this.currentPageAct = 1;
      this.pageSizeAct = 10;
      this.queryActList();
      this.dialogAct = true;
    },
    async queryActList() {
      let params = {
        pageSize: this.pageSizeAct,
        pageNo: this.currentPageAct,
        storeCode: this.storeCode
      };
      const { result } = await this.$store.dispatch(
        "queryStoreRewardList",
        params
      );
      this.actList = result.records;
      this.totalAct = result.total;

    },
    goShopManage(row){
      this.$router.push({
        name: "ShopManage",
        query: {
          storeCode: row.store_code,
          ActStoreCode: this.storeCode,
        }
      });
    },
    actDetails(row) {
      this.innerVisible = true;
      this.$store.dispatch("detailsSupplierRewardRuleInfoList", {
        rewardRuleId: row.reward_rule_id
      });
    },
    pagingAct(page) {
      this.currentPageAct = page;
      this.queryActList();
    },
    handleSizeChangeAct(size) {
      this.currentPageAct = 1;
      this.pageSizeAct = size;
      this.queryActList();
    },
  },
};
</script>
<style lang="scss" scoped>
.sales-volumn-dialog {
  width: 800px;
}
@media screen and (max-width: 600px) {
  .sales-volumn-dialog {
    width: 320px;
  }
}
.m30 {
  margin: 30px;
}
.p30 {
  padding: 30px;
}
.fontBold {
  font-weight: bold;
}
.left-wrapper {
  width: 220px;
  height: 80vh;
  border-right: solid 10px #f4f4f4;
  .headerImg {
    width: 98x;
    height: 98px;
    border-radius: 50%;
  }
  .left-info {
    padding: 10px 30px 10px 30px;
    color: #222222;
  }
  .btn {
    width: 160px;
    display: block;
    margin: 0;
  }
  .mt20 {
    margin-top: 20px;
  }
  .mt10 {
    margin-top: 10px;
  }
  .switch-div {
    width: 160px;
    height: 82px;
    border: 1px solid #d5d5d5;
    border-radius: 4px;
    .title {
      height: 34px;
      line-height: 34px;
      background: #f7f7f7;
      border-radius: 4px;
      text-align: center;
      font-size: 14px;
      color: #222222;
    }
  }
}
.right-wrapper {
  .topType-div {
    border-bottom: solid 10px #f4f4f4;
    padding: 10px 30px;
  }
  .right-info {
    .right-info-title {
      min-width: 80px;
      text-align: right;
      margin-right: 20px;
      font-size: 14px;
      font-weight: bold;
      color: #222222;
      line-height: 16px;
    }
    .right-info-text {
      font-size: 14px;
      line-height: 16px;
      color: #222222;
      padding: 10px;
      border: 1px solid #dddddd;
      border-radius: 4px;
      .tips {
        font-size: 12px;
        color: #e50065;
        line-height: 20px;
        border: 1px solid #e50065;
        height: 20px;
        border-radius: 20px;
        padding: 0 10px;
        text-align: center;
        margin-left: 10px;
        background: #fedeec;
      }
    }
    .ml20 {
      margin-left: 20px;
    }
  }
  .shopImg {
    width: 134px;
    height: 134px;
    border-radius: 8px;
  }
}
.right-info-encryption {
  padding: 10px;
  border: solid 1px #d4d4d4;
  border-radius: 8px;
  margin-left: 130px;
  .item {
    border: 1px solid #dddddd;
    min-height: 50px;
    .title {
      height: 100%;
      background: #f7f7f7;
      padding: 0 20px;
      .in {
        align-self: center;
      }
    }
    .tips {
      height: 18px;
      line-height: 18px;
      background: #d9fedf;
      border-radius: 0px 0px 0px 6px;
      font-size: 10px;
      color: #2fc348;
      padding: 0 10px;
      &.danger {
        background: #fed9d9;
        color: #ff0000;
      }
    }
    .ml10 {
      margin-left: 10px;
    }
  }
  .ml20 {
    margin-left: 20px;
  }
  .h50 {
    height: 50px;
    border-bottom: 1px solid #dddddd;
  }
}
.box-offline {
  background: #ffffff;
  .icon_dengyu {
    background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-dengyu.png")
      no-repeat;
    background-size: 100% 100%;
    width: 30px;
    height: 30px;
  }
  .icon_jiahao {
    background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-jia.png")
      no-repeat;
    background-size: 100% 100%;
    width: 30px;
    height: 30px;
    margin: 0 10px;
  }
  .icon_jianhao {
    background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-jian.png")
      no-repeat;
    background-size: 100% 100%;
    width: 30px;
    height: 30px;
    margin: 0 10px;
  }
  .icon_dui {
    background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-dui.png")
      no-repeat;
    background-size: 100% 100%;
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .icon_cuo {
    background: url("https://imgcdn.hemiao100.com/hemiaoBase/icon/icon-warning.png")
      no-repeat;
    background-size: 100% 100%;
    width: 30px;
    height: 30px;
    margin-right: 10px;
  }
  .title {
    color: #222222;
    font-weight: bold;
    &::before {
      display: inline-block;
      content: "";
      width: 4px;
      height: 14px;
      background: #e50065;
    }
  }
  .bill {
    padding: 20px;
    border: 1px solid #dddddd;
    margin-top: 20px;
    .bill-item {
      margin-top: 12px;
    }
    .total {
      padding: 0 10px;
      min-width: 148px;
      height: 56px;
      background: #ffffff;
      border-radius: 8px;
      opacity: 1;
      border: 1px solid #e50065;
      font-weight: 500;
      color: #222222;
      font-size: 14px;
      margin-right: 10px;
      .num {
        font-size: 28px;
        font-weight: 600;
        color: #e50065;
        margin-left: 10px;
      }
    }
    .item-div {
      padding: 0 10px;
      // height: 56px;
      border-radius: 8px;
      opacity: 1;
      border: 1px dashed #ababab;
      .item {
        border: solid 1px #dddddd;
        height: 32px;
        border-radius: 8px;
        margin: 10px;

        .left {
          padding: 0 10px;
          background: #f1f2f5;
          height: 32px;
          line-height: 32px;
          text-align: center;
          font-size: 14px;
          color: #222222;
        }
        .right {
          padding: 0 10px;
          min-width: 35px;
          text-align: center;
          font-size: 14px;
          color: #222222;
          height: 32px;
          line-height: 32px;
        }
      }
    }
  }
  .check {
    min-width: 80px;
    height: 38px;
    padding: 0 10px;
    background: #e6f6ea;
    border-radius: 59px;
    opacity: 1;
    border: 1px solid #a4dbaf;
    color: #37b44f;
    font-size: 16px;
    margin-left: 20px;
  }
  .check_cuo {
    background: #ffbdb0;
    color: #424242;
    border: 1px solid #ffbdb0;
  }
  .check2_cuo {
    background: #ffbdb0;
    color: #424242;
    border: 1px solid #ffbdb0;
    margin-left: 15px;
    margin-top: 12px;
    display: block;
    width: 120px;
  }
  .check2 {
    margin-left: 35px;
    margin-top: 12px;
    display: block;
    width: 80px;
  }
  .dengyu2 {
    transform: rotate(90deg);
    margin-top: 12px;
    margin-left: 65px;
  }
  .jianhao2 {
    margin-top: 12px;
    margin-left: 65px;
  }
}
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 100px;
    height: 100px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.modal-table {
  border: 1px solid #ddd;
  border-radius: 5px;
  text-align: center;
  .table-header {
    background: #f7f7f7;
    > div {
      padding: 15px;
      color: #222;
    }
  }
  .table-body {
    padding: 15px;
  }
}
.order-info{
  padding: 10px 30px;
  .bold{
    font-weight: bold;
  }
  .text{
    font-size: 12px;
  }
}
.priviewbgp2 {
  position: relative;
  width: 100px;
  height: 100px;
  padding: 10px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
</style>